<template>
  <div v-if="loggedIn" class="redeem-gift-page">
    <div v-on:click.stop class="address-form-container">
      <div class="form-header">
        <p>Write Your Address</p>
      </div>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form action="*" v-on:submit.prevent>
          <div class="form-main-content">
            <ValidationProvider name="First Name" class="address-input half" rules="required" v-slot="{ errors }">
              <input v-model="address.firstName" :placeholder="'First Name'" type="text">
              <p>{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider name="Last Name" class="address-input half" rules="required" v-slot="{ errors }">
              <input v-model="address.lastName" :placeholder="'Last Name'" type="text">
              <p>{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider name="Address" class="address-input" rules="required" v-slot="{ errors }">
              <input v-model="address.address" :placeholder="'Address'" type="text">
              <p>{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider name="Country" class="address-input half" rules="required" v-slot="{ errors }">
              <country-select :whiteList="['US','CA']" :autocomplete="true" :countryName="true" v-model="address.country" :country="address.country" topCountry="US" />
              <p>{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider name="State" class="address-input half" rules="required" v-slot="{ errors }">
            <region-select :autocomplete="true" :countryName="true" :regionName="true" v-model="address.state" :country="address.country" :region="address.state" />
              <p>{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider name="City" class="address-input" rules="required" v-slot="{ errors }">
              <input v-model="address.city" :placeholder="'City'" type="text">
              <p>{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider name="Zip/Postal Code" class="address-input" rules="required" v-slot="{ errors }">
              <input v-model="address.zipCode" :placeholder="'Zip/Postal Code'" type="text">
              <p>{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider name="Phone Number" class="address-input" rules="required" v-slot="{ errors }">
              <input v-model="address.phone" :placeholder="'Phone'" type="text">
              <p>{{ errors[0] }}</p>
            </ValidationProvider>
          </div>
          <div class="form-footer">
            <button type="button" @click="handleSubmit(goCheckout)" class="hb-btn primary" :class="isLoading ? 'isLoading' : ''">{{ buttonText }}</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
  <div v-else class="spinner-container" :class="reclaimed ? 'top' : ''">
    <p v-if="invalidToken">Invalid Access</p>
    <div class="reclaimed-container" v-else-if="reclaimed">
      <p class="title">
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
        <span>Great Choice</span>
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
      </p>
      <p class="subtitle">You'll receive updates and tracking info via email!</p>
    </div>
    <div v-else class="loading-container">
      <p>
        If you are having trouble loading this page, please turn off your VPN or company wifi. <br class="desktop"/> Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift.<br class="desktop"/>
        If you are still having issues, please reach out to <a href="mailto:orders@happyboxstore.com">orders@happyboxstore.com</a> for immediate assistance.
      </p>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import countries from './assets/countries-regions.js'
export default {
    data(){
        return {
            loggedIn: false,
            apiUrl: "https://portal.happyboxstore.com:5054",
            giftToken: null,
            invalidToken: null,
            isLoading: false,
            reclaimed: false,
            currentStep: 0,
            address:{firstName:"",lastName:"",company:"",address:"",address2:"",country:"United States",state:"",city:"",zipCode:"",phone:""},
            selectedAddresses: [],
        }
    },
    components: {
    },
    methods:{
        async goCheckout(){
          if(this.isLoading)
            return
          this.isLoading = true;
          await this.validateToken();
          await this.multiship();
        },
        async login(){
          this.giftToken = localStorage.getItem("emailToken");
          if(!this.giftToken){
            this.invalidToken = true;
            return;
          }
          let response = await axios.post(`${this.apiUrl}/giving/emailLogin`,{token: this.giftToken})
          if(response.data){
            response = response.data;
            if(response.error){
              this.invalidToken = true;
              return;
            }
            else if(response.reclaimed){
              this.reclaimed = true;
            }
            else if(response.cancelled){
              this.invalidToken = true;
            }
            else{
              this.productData = response.data;
              this.loggedIn = true;
            }
          }
        },
        async validateToken(){
          let response = await axios.post(`${this.apiUrl}/giving/emailLogin`,{token: this.giftToken})
          if(response.data){
            response = response.data
            if(response.error || response.cancelled || response.reclaimed){
              location.reload();
            }
          }
          else {
            location.reload();
          }
        },
        async multiship(){
          this.selectedAddresses = [];
          let price = this.trueAddress.country == "United States" ? 0 : 0;
          let name = this.trueAddress.country == "United States" ? "Shipping" : "International";
          this.selectedAddresses.push({address: this.trueAddress,shipping:[{name:name,price:price}],selected:null});
          this.getMultiship();
        },
        async getMultiship(){
          let shippingLines = this.selectedAddresses.map((x) =>{
            return { name:x.shipping[0].name,price:x.shipping[0].price,address:x.address};
          })
          var giftShipData = {myshopify_url:"happy-box-store.myshopify.com",line_items:[this.dataToAdd],shipping_lines:shippingLines};
          var jsonData = JSON.stringify(giftShipData);
          if(this.productData.variant_id == 41663054184613){
            var checkoutData = await this.getGiftShipCheckout({jsonData:jsonData});
            ga('send', {
              hitType: 'event',
              eventCategory: 'Multiship',
              eventAction: 'Navigation',
              eventLabel: `Finish`
            });
            localStorage.setItem('_gs-redirect',true);
            localStorage.removeItem("emailToken");
            location.href = checkoutData.data.checkout_url.checkoutUrl;
          }
          else{
            var checkoutData = await this.getCuratedCheckout({jsonData:jsonData});
            localStorage.setItem('_gs-redirect',true);
            localStorage.removeItem("emailToken");
            location.href = checkoutData.data.draftOrder.invoiceUrl;
          }
        },
        async getCuratedCheckout(jsonData){
          return await axios
            .post('https://api.happyboxstore.com/api/bundle/redeem',jsonData
            ).catch((err) => {
              console.log(err);
            });
        },
        async getGiftShipCheckout(jsonData){
          return await axios
            .post('https://api.happyboxstore.com/api/bundle/multiship',jsonData
            ).catch((err) => {
              console.log(err);
            });
        },
    },
    computed:{
      dataToAdd(){
        let data = {};
        let properties = {};
        let propertiesRemove = ["gif","notificationDate","message","emailShipping","_gs_a","Address","_gs_variant_id","_emailShipping"]
        for(let property of this.productData.properties){
          if(propertiesRemove.includes(property.name)){
            continue
          }
          if(property.name.includes("__gs_")){
            if(property.value)
              properties[property.name.replace("_","")] = JSON.parse(property.value);
          }
          else {
            properties[property.name] = property.value;
          }
        }

        if(properties._gs_bundle_prices){
          properties._gs_bundle_prices = properties._gs_bundle_prices.map(x => 0);
        }
        properties._emailGift = this.giftToken;
        properties["_gs_bundle_discount"] = 30000;
        properties._redeem = true;
        if(!this.productData.product_id || !this.productData.variant_id){
          data = {
            product_id:7747016589477
            ,variant_id:41663054184613
            ,quantity: this.productData.quantity
            ,address: this.trueAddress
            ,properties: properties
            ,itemPrice: 0
          }
        }
        else {
          data = {
            product_id:this.productData.product_id
            ,variant_id:this.productData.variant_id
            ,quantity: this.productData.quantity
            ,address: this.trueAddress
            ,properties: properties
            ,itemPrice: 0
          }
        }
        return data;
      },
      trueAddress(){
        if(this.completeAddress && this.addressString){
          return {
              name: `${this.completeAddress.firstName} ${this.completeAddress.lastName}`,
              first_name: this.completeAddress.firstName,
              last_name: this.completeAddress.lastName,
              address1: this.completeAddress.address,
              address2: "",
              city: this.completeAddress.city,
              state: this.completeAddress.state,
              country: this.completeAddress.country,
              zip: this.completeAddress.zipCode,
              phone: this.completeAddress.phone,
              company: "",
              province_code:this.completeAddress.province_code,
              country_code:this.completeAddress.country_code,
              country_name:this.completeAddress.country
            } 
        }

        return null;
      },
      buttonText(){
        return this.isLoading ? "loading..." : "Next"
      },
      addressString(){
        return `${this.address.firstName} ${this.address.lastName}, ${this.address.address}, ${this.address.city}, ${this.address.state}, ${this.address.country}, ${this.address.zipCode}, ${this.address.phone}`
      },
      completeAddress(){
          let address = JSON.parse(JSON.stringify(this.address));
          let country = countries.find(x => x.countryName == address.country);

          if(country){
            address.country_name = address.country;
            address.country_code = country.countryShortCode;
            let region = country.regions.find(x => x.name == address.state)
            if(region){
              address.province_code = region.shortCode;
            }
          }

          return address
        },
      },
      mounted(){
        this.login();
      },
}
</script>

<style>

    p,span{
      color: #0F0C38;
      margin: 0;
    }

    .redeem-gift-page{
      cursor: pointer;
      text-align: center;
      background: rgba(43,46,56,.9);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5% 0%;
    }

  .happybox-button.orange{
    padding: 1% 10%;
    font-size: 1.5vw;
    border: 1px solid #d9bd47;
  }

  .main-container{
    text-align: center;
    padding-bottom: 5%;
  }

  .main-container .main-title{
    margin-top: 1%;
    font-size: 1.15vw;
    font-weight: 500;
  }

  .next-step{
    font-size: 1.8vw;
    margin: 2% 0%;
  }

  .next-step span,.next-step strong{
    font-style: italic;
    font-family: moret,sans-serif;
  }

  .main-legend{
    text-align: left;
    font-size: 1.6vw;
    padding-bottom: 5%;
  }

  .products-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 100%;
    margin: 3% 0%;
    gap: 30px 15px;
    padding: 0% 15%;
  }

  .product-container {
    width: 23%;
  }

  .product-container .main-image {
    background-color: #f6f6f6;
    width: 100%;
    cursor: pointer;
  }

  .product-container .hover-image {
    background-color: #f6f6f6;
    width: 100%;
    height: 100%;
    object-fit: contain;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    -webkit-transition: all .35s ease-in-out;
    transition: all .35s ease-in-out;
  }

  .product-image-container:hover .hover-image {
    opacity: 1;
  }

  .product-container .product-title{
    font-size: 1vw;
    margin: 5% 0%;
    font-weight: bold;
    text-align: center;
    line-height: 1.2;
  }

  .product-image-container{
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .product-image-container.selected{
    border: 2px solid #0d0574;
  }

  .hover-container {
    display: flex;
    position: absolute;
    width: 100%;
    bottom: -30%;
    margin: unset;
    -webkit-transition: all .35s ease-in-out;
    transition: all .35s ease-in-out;
    background-color: rgba(225,231,253,0.8);
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    z-index: 2;
  }

  .hover-container img{
    width: 10%;
  }

  .hover-container p{
    color: #5A6BA3;
    font-size: 1vw;
    padding: 2% 0%;
    font-weight: bold;
    letter-spacing: 0.2px;
  }

  .product-image-container:hover .hover-container{
    bottom: 0%;
  }

  .product-container .white{
    border: 1px solid #CFCED8 !important;
  }

  .product-container button{
    padding: 4% 9% !important;
  }

  .continue-container button{
    border: 1px solid #CFCED8;
    padding: 1% 10%;
  }

  .happybox-button.white,.happybox-button.purple,.happybox-button.yellow{
    font-size: 1vw;
    padding: 1% 15%;
  }

  .happybox-button.purple:hover{
    background-color: #e6d7fa;
  }

  .slick-slider{
    width: 100%;
  }

  .slick-track {
  display: flex!important;
}

.slick-slide {
  height: inherit!important;
  display: flex!important;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.slick-slide div{
  width: 100%;
}

.slick-slider {
  margin-bottom: 15px;
}

.slick-arrow:before {
  content: ""!important;
}

  .loading-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .loading-container p{
    font-size: 1.15vw;
    color: #0f0c38;
    font-family: "Karla";
    margin-bottom: 2%;
    text-align: center;
  }

  .spinner-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
  }

  .spinner-container.top{
    align-items: flex-start;
    padding-top: 5%;
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.3);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s ease infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .reclaimed-container{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .reclaimed-container .title{
    font-size: 6vw;
    font-family: moret;
    font-weight: bold;
    display: flex;
    gap: 30px;
    width: 100%;
    justify-content: center;
  }

  .reclaimed-container .title img{
    width: 3%;
  }

  .reclaimed-container .subtitle{
    font-size: 3vw;
    font-family: 'moret';
    font-weight: 300;
    width: 35%;
    text-align: center;
    line-height: 1.2;
  }

  .gifting-header{
    display: flex;
    align-items: center;
    padding: 2%;
    position: relative;
  }

  .header-step{
    width: 33.3%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header-step .title{
    color: #908FA3;
    font-family: karla;
    font-size: 0.85vw;
    margin: unset;
    font-weight: bold;
  }

  .header-step.current .title{
    color: #2146A7;
  }

  .header-step .circle{
    width: 0.9vw;
    height: 0.9vw;
    opacity: 0.46;
    border: 1.5px solid #0f0c38;
    background-color: white;
    border-radius: 20px;
    margin: unset;
  }

  .header-step.current .circle{
    background-color: #CCDAFF;
    opacity: 1;
    z-index: 1;
  }

  .header-line{
    width: 100%;
    position: absolute;
    left: 0%;
    border-top: 1.5px solid black;
    bottom: 38.5%;
  }

  @media only screen and (max-device-width: 767px){

    .wiggle img{
      width: 100%;
      left: unset;
    }
    
    .gift-choice-page .header .title{
      font-size: 8vw;
    }

    .main-container .main-title{
      display: none;
    }

    .product-container {
      width: 48%;
    }

    .happybox-button.orange{
      font-size: 3.5vw;
      width: 100%;
      margin-top: 5%;
    }

    .happybox-button.white, .happybox-button.purple,.happybox-button.yellow{
      font-size: 3.5vw;
    }

    .next-step{
      font-size: 5vw;
      margin: 5% 0%;
    }

    .continue-container{
        width: 100%;
        background-color: white;
        display: flex;
    }

    .continue-container.sticky{
      position: fixed;
      bottom: 0%;
      left: 0;
      padding: 5%;
      border-top: 1px solid black;
      align-items: center;
      justify-content: center;
    }

    .continue-container button{
      font-size: 3.5vw;
      width: 100%;
      padding: 2% !important;
      border: unset !important;
    }

    .gifting-header{
      justify-content: center;
    }

    .header-step{
      width: 50%;
    }

    .header-step .title{
      font-size: 3vw;
    }

    .header-step .circle{
      width: 4vw;
      height: 4vw;
    }

    .header-line{
      bottom: 33%;
    }

    .hover-container,.product-container button{
      display: none;
    }

    .product-container .product-title{
      font-size: 3vw;
    }

    .products-container{
      padding: 0% 5%;
      gap: unset;
    }

    .gift-choice-page .header img{
      width: 70%;
    }

    .product-image-container .info{
      width: 15%;
      position: absolute;
      right: 5%;
    }

    .loading-container p{
      font-size: 3vw;
      text-align: center;
    }
  }

  .address-form-page{
    position: fixed;
    z-index: 999999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    cursor: pointer;
    text-align: center;
    background: rgba(43,46,56,.9);
    display: flex;
    align-items: center;
    justify-content: center;
}

.happybox-button{
  padding: 1% 10%;
}

.address-form-container{
  width: 70%;
  max-height: 100%;
  background-color: white;
  position: relative;
  padding: 0;
  vertical-align: top;
  border: 1px solid rgba(0,0,0,.3);
  border-radius: 0.335em;
  box-shadow: 0 19px 38px rgb(0, 0, 0 / 30%), 0 15px 12px transparent;
}

.form-header{
  position: relative;
  padding: 15px 30px;
  border-bottom: 1px solid #dedddd;
  display: flex;
  justify-content: space-between;
}

.form-header p{
  margin: unset;
  font-weight: bold;
  color: #0F0C38;
  font-size: 1.5vw;
}

.form-footer{
  text-align: right;
  padding: 15px;
  border-top: 1px solid #dedddd;
}

.form-main-content{
  max-height: calc(100vh - 170px);
  overflow-y: scroll;
  height: auto;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 15px;
}

.address-input{
  padding: 0% 2% 2%;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.address-input p{
  color: #e32c2b;
  display: block;
  font-size: 12px;
}

.address-input input{
  width: 100%;
}
.address-input.half{
  width: 50%;
}

@media screen and (max-width: 767px) {
  .address-form-container{
    width: 90%;
  }

  .form-header p{
    font-size: 4.5vw;
  }

  input{
    font-size: 16px;
  }
}
  
</style>